<template>
    <ValidationObserver ref="validator" slim>
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
            <v-toolbsar flat>
                <v-toolbar-title>{{ $t('src\\views\\translates\\edit.8035') }}</v-toolbar-title>
            </v-toolbsar>
            <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                    v-model="entity.title"
                    :label="$t('src\\views\\translates\\edit.9150')"
                    outlined
                    :error-messages="errors[0]"
                />
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                    v-model="entity.url"
                    label="Url"
                    outlined
                    :error-messages="errors[0]"
                />
            </ValidationProvider>
            <v-row class="mx-0">
                <v-toolbar-title>{{ $t('src\\views\\translates\\edit.9933') }}</v-toolbar-title>
            </v-row>
            <v-row class="mx-0">
                <template v-for="(value, index) in entity.values">
                    <v-col
                        :key="index"
                        cols="12"
                        class="pa-0">
                        <div
                            class="pa-1 mx-0 my-2"
                            style="border: 1px solid #00000061; border-radius: 4px;">
                            <v-row class="ma-0 d-flex justify-center align-center">
                                <v-text-field
                                    v-model="value.name"
                                    :label="$t('src\\views\\translates\\edit.8348')"
                                    hide-details
                                    outlined
                                    class="ma-1"
                                />
                                <v-btn
                                    color="error"
                                    @click="removeValue(index)"
                                    class="ma-1"
                                >{{ $t('src\\views\\translates\\edit.6924') }}</v-btn>
                            </v-row>
                            <v-row class="ma-0">
                                <v-textarea
                                    v-model="value.ru"
                                    :label="$t('src\\views\\translates\\edit.1653')"
                                    hide-details
                                    outlined
                                    class="ma-1"
                                />
                                <v-textarea
                                    v-model="value.en"
                                    :label="$t('src\\views\\translates\\edit.8693')"
                                    hide-details
                                    outlined
                                    class="ma-1"
                                />
                            </v-row>
                        </div>
                    </v-col>
                </template>
            </v-row>
            <v-row
                align="center"
                justify="space-between"
                class="mx-0 my-2">
                <v-btn
                    :disabled="!valid"
                    color="primary"
                    @click="addValue">{{ $t('src\\views\\translates\\edit.1992') }}</v-btn>
            </v-row>
            <v-row
                align="center"
                justify="space-between"
                class="mx-0">
                <v-btn
                    :disabled="!valid"
                    color="primary"
                    @click="save">{{ $t('src\\views\\translates\\edit.4863') }}</v-btn>
                <v-btn
                    v-if="entity._id"
                    color="error"
                    @click="remove">{{ $t('src\\views\\translates\\edit.5937') }}</v-btn>
            </v-row>
        </v-form>
    </ValidationObserver>
</template>

<script>
    import store from '@/store';
    import { mapState } from 'vuex';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { imageSrc } from '../../helpers';

    export default {
        name: 'TranslatesEdit',
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        data: () => ({
            imageSrc,
            valid: true
        }),
        computed: {
            ...mapState('translates', ['entity']),
        },
        async mounted() {
            if(this.$route.params.id) {
                await store.dispatch('translates/get', { id: this.$route.params.id });
            } else {
                await store.commit('translates/CLEAR_ENTITY');
            }
        },
        methods: {
            addValue() {
                this.entity.values.push({
                    name: '',
                    ru: '',
                    en: ''
                });
            },
            removeValue(index) {
                this.entity.values.splice(index, 1);
            },
            async save() {
                this.valid = await this.$refs.validator.validate();
                if(this.valid){
                    await store.commit('translates/SET_ENTITY', this.entity);
                    await store.dispatch('translates/save');
                    await this.$router.push({ name: 'translates-list' });
                }
            },
            async remove() {
                await store.dispatch('translates/delete', { id: this.entity._id });
                await this.$router.push({ name: 'translates-list' });
            }
        }
    }
</script>

<style lang="scss">
    .v-image {
        width: 300px;
        margin: 0 auto 20px;
        border-radius: 6px;
    }
</style>
